import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { DropdownChooser, DropdownChooserView } from '../../components/DropdownChooser/DropdownChooser';
import { TextInputDecorator } from '../../components/TextInputDecorator/TextInputDecorator';
import { Bem } from '../../service/Bem/Bem';
import { Order } from '../common/typings';
import { GalleryCategoryData } from '../GalleryPane/typings';

import './GalleryPaneFilters.css';
import * as keyset from './GalleryPaneFilters.i18n';

const i18n = i18nFactory(keyset);

const BLOCK = 'gallery-pane-filters';

export interface GalleryPaneOrderFilterProps {
    recentOrder: Order;
    changeRecentOrder: (order: Order) => void;
}

export interface GalleryPaneNameFilterProps {
    changeRecentNameFilter: (filter: string) => void;
    recentNameFilter: string;
}

export class GalleryPaneNameFilter extends React.PureComponent<GalleryPaneNameFilterProps> {
    render() {
        const { recentNameFilter, changeRecentNameFilter } = this.props;

        return (
            <>
                <TextInputDecorator
                    theme={'normal'}
                    size={'s'}
                    cls={Bem.cls(BLOCK, 'recent-name-filter')}
                    placeholder={i18n('search-input-text')}
                    text={recentNameFilter}
                    onChange={changeRecentNameFilter}
                />
            </>
        );
    }
}

export interface GalleryPaneSemanticTextFilterProps {
    semanticText: string;

    changeSemanticTextFilter: (filter: string) => void;
}

export class GalleryPaneSemanticTextFilter extends React.PureComponent<GalleryPaneSemanticTextFilterProps> {
    render() {
        const { semanticText, changeSemanticTextFilter } = this.props;

        return (
            <TextInputDecorator
                theme={'normal'}
                size={'s'}
                cls={Bem.cls(BLOCK, 'semantic-text-filter')}
                placeholder={i18n('video-stock-search-input-text')}
                text={semanticText}
                onChange={changeSemanticTextFilter}
            />
        );
    }
}

export interface GalleryPaneCategoriesFilterProps {
    selectedGalleryCategories: string[];
    categoriesData?: GalleryCategoryData[];

    fetchGalleryCategoriesData: () => void;
    selectGalleryCategory: (selectedId: string) => void;
}

interface GalleryPaneCategoriesFilterInnerProps extends GalleryPaneCategoriesFilterProps {
    getButtonText: (count: number) => string;
}

const DROPDOWN_CHOOSER_WIDTH = 327;
const DROPDOWN_CHOOSER_SEARCH_FILTER = { isEnabled: true };

export class GalleryPaneCategoriesFilter extends React.PureComponent<GalleryPaneCategoriesFilterInnerProps> {
    render() {
        const { selectedGalleryCategories, categoriesData } = this.props;

        return (
            <DropdownChooser
                size={'s'}
                popupCls={Bem.cls(BLOCK, 'categories-chooser')}
                view={DropdownChooserView.withControls}
                labelButton={this.getGalleryCategoriesButton()}
                onChange={this.props.selectGalleryCategory}
                onOpen={this.onOpenGalleryCategoriesChooser}
                width={DROPDOWN_CHOOSER_WIDTH}
                menuItems={categoriesData}
                value={selectedGalleryCategories}
                searchFilter={DROPDOWN_CHOOSER_SEARCH_FILTER}
                isMulti={true}
            />
        );
    }

    private onOpenGalleryCategoriesChooser = () => {
        if (!this.props.categoriesData) {
            this.props.fetchGalleryCategoriesData();
        }
    };

    private getGalleryCategoriesButton() {
        const { selectedGalleryCategories, getButtonText } = this.props;
        const count = selectedGalleryCategories.length;

        return getButtonText(count);
    }
}
